import { connect } from "react-redux";

import {
  add_mandator_organisation,
  remove_mandator_organisation,
} from "./mandator.actions";

function mapStateToProps(state) {
  return { users: state.users };
}

function mapDispatchToProps(dispatch) {
  return {
    addMandatorToOrganization: (mandatorIdentity, identity) => {
      dispatch(add_mandator_organisation(mandatorIdentity, identity));
    },
    removeMandatorToOrganization: (mandatorIdentity, identity) => {
      dispatch(remove_mandator_organisation(mandatorIdentity, identity));
    },
  };
}

export const mandatorsConnector = connect(mapStateToProps, mapDispatchToProps);
